import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createLead = (payload) =>
  axios.post(`${API}/leads`, payload).then((r) => r.data);

export const createDiagnosis = (payload) =>
  axios.post(`${API}/diagnosis`, payload).then((r) => r.data);

export const fetchLeads = (token) =>
  axios
    .get(`${API}/leads`, { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

export const fetchStats = (token) =>
  axios
    .get(`${API}/stats`, { headers: { "X-Admin-Token": token } })
    .then((r) => r.data);

export const requestNarration = (payload) =>
  axios.post(`${API}/tts/narrate`, payload).then((r) => r.data);

export { BACKEND_URL };
